namespace $.$$ {
	export class $shm_hitalama_components_preview extends $.$shm_hitalama_components_preview {
		loader() { return this.demo_model().loader() }
		instance() { return this.demo_model().result()?.component ?? null }
		content() { const instance = this.instance(); return instance ? [ instance ] : [] }
		fullscreen_arg() { return { fullscreen_application: this.definition().class_name(), fullscreen_widget: null } }
	}
}
